import store from "@/store/index.js";
import { jAlert3, jAlert5 } from "@/base/jAlert/jAlert";
import { getStorage } from "@/utils/wxuser";
import { blackListApi } from "@/utils/blackListApi.js";
var Fly = require("flyio");
Fly.interceptors.request.use(request => {

	// store.dispatch("openLoading", "加载中...");
	// if(blackListApi.indexOf(request.url)>-1){

	// 	store.dispatch("openLoading", "加载中...");
	// }
	let user = getStorage("user");
	if (request.body && request.body.memberId) {
		if (user && user.memberToken) {
			request.body.memberToken = user.memberToken;
			request.headers.memberToken = user.memberToken;
		}
		if (request.method == "GET" && getStorage("isOpenGlobalSafe") == "T") {
			delete request.body.memberId
		}
	}
	if(request.body && request.url.indexOf('/api/shop/syncUploadImageByWechat.json')>-1){
		request.body.memberToken = user.memberToken;
	}
	// if (user && user.memberToken){
	// 	request.headers.memberToken = user.memberToken;
	// }
	let gateway = sessionStorage.getItem("gateway");
	if (request.url.indexOf("/api") > -1 && gateway == 'T' && request.url.indexOf('http') !== 0) {
		request.url = `/guardian${request.url}`
	}

	return request;
});

Fly.interceptors.response.use(
	(response, promise) => {
		//console.log(response)
		// store.dispatch('closeLoading')
		const status = response.status;
		if (status === 200 && response.data) {
			store.dispatch('closeLoading')
			return promise.resolve(response.data);
		}
	},
	(err, promise) => {
		console.log(err)
		jAlert3(err.status, err.message)
		// store.dispatch('closeLoading')
		return promise.resolve();
	}
);



// WEBPACK FOOTER //
// ./src/utils/requestNew.js